import type { ComponentType, SVGProps } from "react";
import { Link, useLocation } from "react-router";
import { Icon } from "@astryxdesign/core/Icon";
import { Text } from "@astryxdesign/core/Text";
import { GlassLens } from "./GlassLens";

export interface NavItem {
  to: string;
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  end?: boolean;
}

/**
 * Floating liquid-glass tab bar (thumb reach), respecting the home-indicator
 * safe area. The active tab sits under a glass lens that flows between tabs.
 */
export function BottomNav({ items, label }: { items: NavItem[]; label: string }) {
  // Matched here rather than by NavLink: /s/x and /s/x/ are the same home.
  const path = useLocation().pathname.replace(/\/+$/, "");
  const isActive = (item: NavItem) => path === item.to || (!item.end && path.startsWith(`${item.to}/`));
  return (
    <nav className="bottom-nav glass-surface" aria-label={label}>
      <ul className="flex list-none">
        {items.map((item) => (
          <li key={item.to} className="flex flex-1">
            <Link to={item.to} aria-current={isActive(item) ? "page" : undefined}>
              {isActive(item) ? <GlassLens group={label} /> : null}
              <Icon icon={item.icon} size="md" />
              <Text type="supporting" size="2xs" color="inherit" maxLines={1} hasTruncateTooltip={false}>
                {item.label}
              </Text>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
